<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row align-items-center justify-content-between">
					<div class="col-12">
						<h2 class="mb-4 pb-2 pt-2 d-flex align-items-start">
							<span>Employee: {{ provider_data.first_name }} {{ provider_data.last_name }}
								<!-- <br/><small class="font-italic">ssn: {{ provider_data.ssn }}</small> -->
							</span>
						</h2>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
			<div class="col-12 col-xl-12">
				<form @submit.prevent="onSubmit">

					<div class="mb-2">
						<div class="row">
							<div class="col">
								<label class="mb-2 h6 green">1. PERSONAL INFO</label>
							</div>

							<div class="col">
							<div class="text-right">
                  			<div class="d-inline-block">
                  			<provider-status-action
                    		:key="provider_data.id"
							:user_status="provider_data.provider_status_id"
                    		:provider="provider_data"
                    		@updateStatusProvider="updateStatusProvider"
                    		/>
                    	</div>
						<hub-spot-ticket
						:provider_name="provider_data.first_name"
						:provider_last_name="provider_data.last_name"
						:provider_country_code="provider_data.country_code"
						:provider_phone="provider_data.phone"
						:provider_email="provider_data.email"
						></hub-spot-ticket>
						<button type="button" class="button ml-3" @click="showHistory">Employee history</button>
						<div class="ml-3 trigger-hidden-content ml-1 d-inline-block">
							<span class="text-right button">
								Actions <i class="fa fa-caret-down" aria-hidden="true" style="vertical-align: baseline"></i>
							</span>
							<div class="hidden-content hc-right-bottom">
								<div>
									<ul class="list-unstyled text-left">
										<template>
											<password-action :user_role="'organization'" :checked_user="1"
											:sign_up="provider_data.sign_up"></password-action>
										</template>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

					<div class="lightgray-content p-3 rounded mb-2">

						<div class="row">
							<div class="col-12 col-lg-4  col-xl-3">
								<div class="form-group input-content">
									<label>IMAGE</label>
									<div class="thumb-container circle-thumb profile-thumb" :style="{ 'background-image' : 'url(data:image/jpeg;base64,'+provider_data.image+')' }"></div>
									<!-- <p class="text-center"><a class="button" href="#">Change image</a></p> -->
								</div>
              <div v-if="show_shift_blocking">
                <shift-blocking-view :provider_data="provider_data" />
              </div>
							</div><!--col-->
							<div class="col-lg-8">
								<label class="mb-2 h6">1. General info</label>
								<div class="row">
									<div class="col-12 col-lg-6">
										<div class="form-group input-content">
											<label>Email</label>
											<input disabled placeholder="Email" type="text" v-model="provider_data.email" class="form-control" v-validate="'email|email_unique_update:'+provider_data.uid" name="email">
											<span class="input-error-msg">{{ errors.first('email') }}</span>
										</div>
										<div class="form-group input-content">
											<label>First name</label>
											<input  placeholder="First name" type="text" v-model="provider_data.first_name" class="form-control" v-validate="'required'" name="first_name">
											<span class="input-error-msg">{{ errors.first('first_name') }}</span>
										</div>
										<div class="form-group input-content">
											<label>Last name</label>
											<input placeholder="Last name" type="text" v-model="provider_data.last_name" class="form-control" v-validate="'required'" name="last_name">
											<span class="input-error-msg">{{ errors.first('last_name') }}</span>
										</div>
										<!-- <div class="form-group input-content">
											<label>Gender</label>
											<v-select  class="mb-2"  :searchable="false"  v-model="provider_data.gender"
												:options="[{ 'value' : '-', 'label' : '-'}, { 'value' : 'Male', 'label' : 'Male' }, { 'value' : 'Female', 'label' : 'Female' }]">
											</v-select>
										</div> -->
										<div class="form-group input-content">
											<label>Employee number</label>
											<input placeholder="Employee number" type="text"  class="form-control" name="employer_number"
											v-model="provider_data.employer_number"
												>
											<span class="input-error-msg">{{ errors.first('employer_number') }}</span>
										</div>
										<div class="input-content">
											<label>Discipline</label>

											<v-select class="mb-2 v-select-no-height discipline" multiple :searchable="true"  track-by="id" label="name" name="organization_discipline_id" allowClear="true"
											:value="discipline_array" :options="disciplines" v-validate="provider_data.discipline_mandatory == 1 "
											>


											</v-select>
											<span class="input-error-msg">{{ errors.first('organization_discipline_id') }}</span>
										</div>


									</div><!--col-->
									<div class="col-12 col-lg-6">
										<!-- <div class="form-group input-content">
											<label>Birthday</label>
											<div class="row ml-0">
												<date-picker  class="date_picker_new" v-model="provider_data.dob"  :range="false" :format="'MM-DD-YYYY'"
												placeholder="Birthday"
												:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
												:valueType="'YYYY-MM-DD'">
												</date-picker>
											<span class="input-error-msg">{{ errors.first('dob') }}</span>

											</div>


										</div> -->

										<div class="form-group input-content">
											<div class="row">
												<div class="col-5">
													<label>Country code</label>
													<v-select class="mb-2" name="country_code" :searchable="true" :options="country_codes" v-model="provider_data.country_code"
															v-validate="'required'">
													</v-select>
													<span class="input-error-msg">{{ errors.first('country_code') }}</span>
												</div>
												<div class="col-7">
													<label>Mobile number</label>
													<input placeholder="Mobile number" type="text" v-model="provider_data.phone" class="form-control" name="phone"
														v-validate="'min:8|max:10'"  style="height: 32px;">
													<span class="input-error-msg">{{ errors.first('phone') }}</span>
												</div>
											</div>
										</div>
										<div class="form-group input-content">
											<label>Preferred language</label>
											<multiselect v-model="provider_data.language" :disabled="!user_meta_actions.includes('change_language')"
									label="value"
									:options="preferred_languages"></multiselect>
										</div>
										<div class="form-group input-content">
											<label>Employment Date</label>
											<div class="row ml-0">
												<date-picker class="date_picker_new"   :range="false"
												 v-model="provider_data.onboard_date"  :format="'MM-DD-YYYY'"
												:placeholder="'Employment Date'"
												:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
												:valueType="'YYYY-MM-DD'"></date-picker>
											</div>
										</div>

										<div v-if="locations_loaded">
											<sub-location-selection

											:mandatory="location_mandatory"
											:locations="locations"
											:selected_location="temp_location_information"
											:organization="provider_data"
											@locationChanged="locationChanged"
											:width_full="true"
											>
										</sub-location-selection>
                    </div>
					                    <div class="form-group">
											<div class="checkbox-container squared">
												<input id="is_applicant"
												type="checkbox" v-model="provider_data.is_applicant"/>
												<label for="is_applicant" style="width:auto; font-size: 14px;
    font-weight: bold;">Is Applicant</label>
											</div>
										</div>
										<!--
										<div class="form-group input-content">
											<label>SSN</label>
											<input disabled  placeholder="SSN" type="text" v-model="provider_data.ssn" class="form-control cursive font-italic" v-validate="" name="email">
											<span class="input-error-msg">{{ errors.first('ssn') }}</span>
										</div>
									-->
									</div><!--col-->


								</div>

							</div>

						</div><!--row-->

						<div class="row">
							<div class="col-md-12">
								<div class="text-right mt-2 mb-3" v-if="user_meta_actions.includes('edit_provider_details_including_roles')">
									<router-link :to="{ name : user_role+'.providers.index' }" tag="button" class="button gray-content large-button">Back</router-link>
									<button type="submit" class="button large-button">Update</button>
								</div>
									<div class="text-right">
										<div id="UUID">API ID: {{ provider_data.uuid ? provider_data.uuid : ''}}</div>
									</div>
							</div>
						</div>
					</div>
				</form>

				<label class="mb-2 h6 green">2. EMPLOYEE INFO</label>

				<template v-if="show_organization_details">
					<provider-organization
          :key="uniqueID"
          :provider="provider_data"
          :organization="{
            id : '_',
            'location_mandatory' : location_mandatory,
            'discipline_mandatory' : discipline_mandatory,
            'is_active' : provider_data.is_active
          }"
          :country_codes="country_codes"
          :show_organization_details="false"
          @getInfo="getProvider"

          ></provider-organization>
				</template>

			</div><!--col-->
		</div><!--row-->

		<!-- provider history -->
		<b-modal v-model="show_history" title="Employee history"  ok-only ok-title="Close" size="lg">
			<table-view :table_headers="['Date','Text', 'By']" :dataOptions="['time','text','by']" v-if="show_history" :history="history"></table-view>
		</b-modal>
		<password-reset :bulk_modals="bulk_modals"  :bulk_selection="bulk_selection"></password-reset>
	</div>
</template>

<script>
import SubLocationSelection from '../../shared/inputs/SubLocationSelection.vue'
import organizationProviderMixin from '../../shared/organizationProviderMixin.js'
import ProvidersMixin from '../../shared/ProvidersMixin.js'
import DatePickerView from '../../shared/inputs/DatePickerView.vue'
import ProviderStatusAction from '../../shared/inputs/ProviderStatusAction.vue'
import DatePickerMixin from '../../shared/inputs/DatePickerMixin'
import ShiftBlockingView from '../../shared/inputs/ShiftBlockingView'
import HubSpotTicket from '../../shared/inputs/HubSpotTicket'
export default {
	mixins: [organizationProviderMixin,DatePickerMixin,ProvidersMixin],
	components : {
		SubLocationSelection,
		DatePickerView,
    ProviderStatusAction,
    HubSpotTicket,
    ShiftBlockingView
	},
	data : function(){
		return {
			user_role:'',
			id : this.$route.params.id,
			provider_data : {
				ssn : '',
				first_name : '',
				last_name : '',
				// dob: '',
				email : '',
				// gender: '',
				language: '',
				phone: '',
				uid : null,
				lhcsa_manager : '',
				coordinator : '',
				manager_approving_the_hha_score : '',
				supporting_rn : '',
				is_active : true,
				onboard_date: null,
				organization_discipline_ids:[],
				is_applicant: true
			},
			preferred_languages : [],
			show_organization_details : false,
			country_codes : [],
			location_mandatory : 0,
			discipline_mandatory : 0,
			disciplines: [],
			can_load_info : false,
			history : [],
			per_page_history : 5,
			current_page_history : 1,
			show_history : false,
			red : this.config.COLORS.RED,
			green : this.config.COLORS.GREEN,
			bulk_modals:{
				show_reset_password_email:false,
				show_reset_password_plain:false,
				show_reset_password_text:false,
				show_sign_up_sso:false,
			},
			bulk_selection : [],
			subrole_config: [],
			user_meta_actions: localStorage.getItem('meta_actions'),
			locations:[],
			temp_location_information: null,
			locations_loaded:false,
      uniqueID:null
		}
	},
  computed:{
    show_shift_blocking(){
      if(this.provider_data){
        if(this.provider_data.hasOwnProperty('shift_blocking_disabled')){
          return true
        }else{
          return false
        }
      }
    }
  },
	watch: {
		'provider_data.phone': function(val){
			if(val != '' || val != null){
				var removedText = val.replace(/\D+/g, '');
				this.provider_data.phone = removedText
			}
		}
	},
	created : function(){
		this.user_role = this.$store.getters.getRole
		this.getProvider();
		this.getHistory();
		this.getCountries();
		this.getLocations();
		this.getDisciplines();
		this.getSubrolesConfig();
	},

	methods : {
		getProvider : function(){

			var params = {
				id : this.id,
				filters : {
						organization_id : '_',
						include_expired : 1
					}
			}

			this.$store.dispatch('getProviderOrganizationDetail', params).then((res) => {
         	this.provider_data = res.data.data;
          this.provider_data.organization_discipline_ids = res.data.data.disciplines
          this.temp_location_information = res.data.data.organization_location_id
          this.getPreferredLanguages();
          this.getMyOrganization();
          this.$forceUpdate();
         this.uniqueID = Date.now().toString(36) + Math.random().toString(36).substr(2);

			}).catch((error) => {
				console.log(error);
			})
		},
		onSubmit : function(){
			this.$validator.validateAll().then((result) => {
				if(result){
						delete this.provider_data['disciplines']
						// delete this.provider_data['language']


					// if(this.provider_data.gender.value){
					// 	this.provider_data.gender = this.provider_data.gender.value;
					// }
					if(typeof this.provider_data.country_code == 'object' &&  this.provider_data.country_code ){
						this.provider_data.country_code = this.provider_data.country_code.value;
					}
					if(this.provider_data.language){
							this.provider_data.language = this.provider_data.language.key;
						}
					if(this.discipline_array.length > 0){
						this.provider_data.organization_discipline_ids = this.discipline_array.map(elem 	=>{ return elem.id
						})
					}else{
						this.provider_data.organization_discipline_ids = []
					}

					var params = {
						id : this.$route.params.id,
						filters : {
							organization_id : '_'
						},
						data : this.provider_data
					}

					this.$store.dispatch('editProviderOrganizationDetail', params).then((res) => {
						//this.$router.push({ name : 'organization.providers.index' });
						this.getPreferredLanguages();
					}).catch((error) => {
						this.getPreferredLanguages();
						console.log(error);
					});
				}
			});
		},
		getPreferredLanguages : function(){
			this.preferred_languages = []
			var params = { filters:{available_for_users: 1} };
			this.$store.dispatch('getLanguages', params).then((res) => {
				for(let i in res.data.data){
					if(this.provider_data.language == res.data.data[i][0].code_2){
						this.provider_data.language = {key:res.data.data[i][0].code_2, value:res.data.data[i][0].name}
					}
					this.preferred_languages.push({key:res.data.data[i][0].code_2, value:res.data.data[i][0].name})
				}
			}).catch((error) => {
				console.log(error);
			});
		},

		getMyOrganization : function(){

			this.$store.dispatch('getMyOrganization', {}).then((res) => {
				this.location_mandatory = res.data.organization.location_mandatory;
				this.discipline_mandatory = res.data.organization.discipline_mandatory;

				this.show_organization_details = true;
			}).catch((error) => {
				console.log(error);
			});
		},
		getSubrolesConfig : function(){
			return
				var params = {
					id : '_'
				}
				this.$store.dispatch('getConfigOrganizationSubrole', params).then((res) => {
					 this.subrole_config.push(res.data)
				}).catch((error) => {
					console.log(error);
				});


			this.$forceUpdate();

		 },
		showHistory : function(){
			this.show_history = true;
		},

		getHistory : function(){

			var params = {
				id : this.id
			}

			this.$store.dispatch('getProviderHistory', params).then((res) => {
				this.history = res.data.data;
			}).catch((error) => {
				console.log(error);
			})
		},

		toggleOrganizationStatus : function(){


			var method = '';

			if(this.provider_data.is_active){

				//deactivate provider

				method = 'deleteProviderFromOrganization';
			}else{
				//activate provider

				method = 'addProviderToOrganization';
			}

			var params = {
				organization_id : '_',
				provider_id : this.id
			}

			this.$store.dispatch(method, params).then((res) => {
				this.provider_data.is_active = !this.provider_data.is_active;

				if(method == 'deleteProviderFromOrganization'){
					this.show_organization_details = false;
					this.getProvider();
				}
			}).catch((error) => {
				console.log(error);
			});

		},
		getCountries : function(){
			this.$store.dispatch('getCountries', {}).then((res) => {
				this.country_codes = res.data.data;
			}).catch((error) =>{
				console.log(error);
			});
		},
		openBulkModal: function(name){
			this.bulk_selection = []
			this.bulk_selection.push({
				id: this.id,
				first_name: this.provider_data.first_name,
				last_name: this.provider_data.last_name,
				email: this.provider_data.email
			})
			this.bulk_modals['show_' + name] = true;
		},

		pushError(date_validation_name){
			console.log(date_validation_name)
		},
	}
}
</script>
<style scoped>
#UUID {
	font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/components/organizations/providers/OrganizationProviderDetailComponent.vue